import { Button, Form } from 'react-bootstrap';
import { PAGE_SIZES } from '../usePagedList';

// Prev / "Page N of M" / Next + a per-page <select>. Pairs with usePagedList:
//
//   const list = usePagedList(loader, { deps: [...] });
//   ...render list.rows...
//   <Pager {...list} />
//
// Renders nothing when there is only a single page and the default page size - a short list
// should not grow a control it doesn't need. `total` (when known) is shown as an "N items"
// hint next to the page size.
export default function Pager({
    page, totalPages, limit, hasMore, total, loading,
    setPage, setLimit, showPageSize = true, className = ''
}) {
    const canPrev = page > 1;
    const canNext = hasMore || page < totalPages;
    const multiPage = totalPages > 1 || hasMore || page > 1;

    if (!multiPage && limit === 20) return null;

    return (
        <div className={`d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3 ${className}`}>
            <div className="d-flex align-items-center gap-2">
                <Button size="sm" variant="outline-secondary" disabled={!canPrev || loading} onClick={() => setPage(page - 1)}>
                    ‹ Prev
                </Button>
                <span className="small text-muted">
                    Page {page}{totalPages > 1 ? ` of ${totalPages}` : ''}
                </span>
                <Button size="sm" variant="outline-secondary" disabled={!canNext || loading} onClick={() => setPage(page + 1)}>
                    Next ›
                </Button>
            </div>
            {showPageSize && (
                <div className="d-flex align-items-center gap-2">
                    {total > 0 && <span className="small text-muted">{total} item{total === 1 ? '' : 's'}</span>}
                    <Form.Label className="small text-muted mb-0">Per page</Form.Label>
                    <Form.Select
                        size="sm"
                        style={{ width: 'auto' }}
                        value={limit}
                        onChange={(e) => setLimit(Number(e.target.value))}
                    >
                        {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
                    </Form.Select>
                </div>
            )}
        </div>
    );
}
